"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverPositionSelect = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var __1 = require("../../");
var PopoverPositionSelect = /** @class */ (function () {
    function PopoverPositionSelect() {
    }
    PopoverPositionSelect.prototype.view = function (_a) {
        var _b = _a.attrs, onSelect = _b.onSelect, otherAttrs = tslib_1.__rest(_b, ["onSelect"]);
        return (0, mithril_1.default)(__1.Select, tslib_1.__assign(tslib_1.__assign({}, otherAttrs), { fluid: true, options: Object.keys(__1.PopoverPosition).map(function (key) { return __1.PopoverPosition[key]; }), onchange: function (e) {
                var target = e.target;
                var position = target.options[target.options.selectedIndex].value;
                onSelect(position);
            }, size: 'xs' }));
    };
    return PopoverPositionSelect;
}());
exports.PopoverPositionSelect = PopoverPositionSelect;
